export const isMacOs = (): boolean => /Mac/i.test(window.navigator.userAgent);
